import api from '@/api'
import { BaseModalProps } from '@/components/modals/base-modal/base-modal'
import FormModal from '@/components/modals/FormModal'
import LoadingButton from '@mui/lab/LoadingButton'
import { Button, DialogContent, DialogContentText, Input } from '@mui/material'
import { t } from 'i18next'
import React from 'react'
import { toast } from 'react-toastify'

const CarLicenseUploadModal: React.FC<BaseModalProps> = ({
  isOpen,
  onClose,
}) => {
  const [isLoading, setIsLoading] = React.useState(false)
  const [selectedFile, setSelectedFile] = React.useState<File | null>(null)

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file && file.type === 'application/pdf') {
      setSelectedFile(file)
    } else {
      toast.error(t('אנא בחר קובץ בפורמט PDF'))
    }
  }

  const onSubmit = async () => {
    if (!selectedFile) {
      toast.error(t('אנא בחר קובץ'))
      return
    }

    setIsLoading(true)
    try {
      const formData = new FormData()
      formData.append('pdf', selectedFile)

      const data = await api.post('ai/car-licence-parser/', {
        ...Object.fromEntries(formData.entries()),
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      const number_of_licenses = (data as any)?.car_licences?.length;

      toast.success(`${number_of_licenses} רשיונות נשמרו בהצלחה`)
      setSelectedFile(null)
      onClose()
    } catch (error) {
      toast.error(t('קובץ לא נשמר'))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <FormModal
      onSubmit={onSubmit}
      isOpen={isOpen}
      onClose={onClose}
      actions={
        <>
          <Button onClick={onClose}>{t('cancel')}</Button>
          <LoadingButton loading={isLoading} type="submit">
            {t('העלה')}
          </LoadingButton>
        </>
      }
    >
      <DialogContent>
        <DialogContentText>{t('העלאת רשיון רכב')}</DialogContentText>
        <Input
          type="file"
          inputProps={{ accept: 'application/pdf' }}
          onChange={handleFileChange}
          fullWidth
          required
        />
      </DialogContent>
    </FormModal>
  )
}

export default CarLicenseUploadModal
